import { NB } from '@cerebral-inc/ui';
import { segmentIntegrations } from '../shared/analytics/segment';

const { Flex, Box, Text, Button } = NB;

interface StepProps {
  title: string;
  description: string;
  index?: number;
}

interface StepsProps {
  steps: StepProps[];
  segmentEventKey: string;
}

const Step = ({ title, description, index }: StepProps) => {
  return (
    <Flex
      flex={1}
      alignItems={{ base: 'flex-start', lg: 'center' }}
      ml={index !== 0 ? { base: 0, lg: '32px' } : {}}
      mt={index !== 0 ? { base: '32px', lg: 0 } : {}}
      flexDir={{ base: 'row', lg: 'column' }}
      pr={{ base: '6px', lg: 0 }}
    >
      <Box
        borderRadius="8px"
        w={{ base: '40px', lg: '48px' }}
        py={{ base: '8px', lg: '12px' }}
        borderColor="#E1E2E8"
        borderWidth="1px"
        mr={{ base: '20px', lg: 0 }}
      >
        <Text
          color="#1C1E21"
          fontSize="18px"
          fontWeight={600}
          lineHeight="24px"
          textAlign="center"
          fontFamily="Poppins"
        >
          {(index || 0) + 1}
        </Text>
      </Box>
      <Box w={{ base: 'calc(100% - 52px)', lg: '100%' }}>
        <Text
          textAlign={{ base: 'left', lg: 'center' }}
          color="#1C1E21"
          fontSize="18px"
          fontWeight={600}
          lineHeight="24px"
          mt={{ base: 0, lg: '20px' }}
          fontFamily="Poppins"
        >
          {title}
        </Text>
        <Text
          textAlign={{ base: 'left', lg: 'center' }}
          color="#4D515A"
          fontSize="14px"
          lineHeight="24px"
          mt="8px"
          fontFamily="Poppins"
        >
          {description}
        </Text>
      </Box>
    </Flex>
  );
};

const Steps = ({ steps, segmentEventKey }: StepsProps) => {
  const handleContinue = () => {
    window.analytics?.track(segmentEventKey, {}, segmentIntegrations);
    window.open(`${process.env.REACT_APP_CLIENT_APP_URL}`, '_self');
  };

  return (
    <Flex
      py={{ base: '40px', sm: '64px' }}
      borderTopColor="#E1E2E8"
      borderColor="#FFFFFF"
      borderWidth="1px"
      alignItems="center"
      px="24px"
    >
      <Flex
        flexDir={{ base: 'column', lg: 'row' }}
        justifyContent="center"
        maxW={{ base: '100%', lg: '1264px' }}
        px={{ base: 0, lg: '24px' }}
      >
        {steps.map(({ title, description }, index) => (
          <Step
            title={title}
            description={description}
            key={title}
            index={index}
          />
        ))}
      </Flex>
      <Button
        w={{ base: '100%', md: '320px' }}
        h="56px"
        _text={{
          fontFamily: 'Poppins',
          fontSize: '14px',
          fontWeight: 600
        }}
        mt={{ base: '32px', md: '64px' }}
        onPress={handleContinue}
      >
        Continue
      </Button>
    </Flex>
  );
};

export default Steps;
